import * as types from './actionTypes'

export const isLoading = payload => {
    return { type: types.ARTISTS_IS_LOADING, payload }
}

export const fetchError = payload => {
    return { type: types.ARTISTS_FETCH, payload }
}

export const fetchSuccess = payload => {
    let data = Object.values(payload.val())
    let keys = Object.keys(payload.val())

    data.map((item, idx) => {
        item.id = keys[idx]

        return null
    })

    return { type: types.ARTISTS_FETCH, payload: data }
}

export const addSuccess = payload => {
    return { type: types.ARTISTS_ADD, payload }
}

export const add = payload => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        firebase
            .push('artists', payload)
            .then(ref => {
                dispatch(addSuccess({ id: ref.key, ...payload }))
            })
    }
}

export const remove = id => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        let linked = getState().eveniments.eveniments.filter(item => item.artistId === id)
        let updates = {}
        linked.map(item => {
            updates[`eveniments/${item.id}`] = null

            return null
        })

        firebase
            .ref()
            .update(updates)

        firebase
            .ref(`artists/${id}`)
            .remove()
            .then(() => {
                dispatch(fetch())
            })
    }
}

export const fetch = () => {
    return (dispatch, getState, getFirebase) => {
        const firebase = getFirebase()

        firebase
            .ref('artists')
            .once('value')
            .catch(error => dispatch(fetchError(error)))
            .then(snapshot => {
                if(snapshot.val()) {
                    dispatch(fetchSuccess(snapshot))
                }
            })
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/artistsActions.js